import React, { useCallback, useEffect, useRef, useState } from "react";
import { CustomTable } from "../../../shared/components/custom-table/custom-table";
import { SERVICES } from "../../../core/services/services";
import { CustomLoader } from "../../../shared/components/custom-loader/custom-loader";
import { Toast } from "primereact/toast";
import { HELPER } from "../../../shared/helper/helper";
import { AccessDenied } from "../../access-denied/access-denied";
import { BulkTransactionBreakDown } from "./bulk-transaction-break-down";
import { Optional } from "../../../shared/components/optional/optional";

export function BulkTransactions(props) {
  const toast = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [error, setError] = useState("");
  const [search, setSearch] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [range] = useState(5);
  const [emptyText, setEmptyText] = useState("");
  const [pageNo, setPageNo] = useState(0);
  const [searchParams, setSearchParams] = useState(null);

  const tableHeaders = [
    { label: "Merchant", value: "merchantName" },
    { label: "Amount", value: "amount" },
    { label: "Time", value: "transactionTime" },
    { label: "Bank Reference", value: "bankReference" },
    { label: "Response code", value: "responseCode" },
    { label: "Actions", value: "actions" },
  ];

  const [details, setDetails] = useState([]);
  const [transactions, setTransactions] = useState([]);

  const getTransactionDetails = useCallback((e, isMobile) => {
    let arr = [];
    setDetails([]);
    for (const prop in e) {
      if (typeof e[prop] === "string") {
        arr.push({
          label: HELPER.CAMEL_TO_TITLE_CASE(prop),
          value: e[prop],
          itemCase: prop,
        });
      }
    }
    setDetails(arr);
    setCurrentIndex(3);
  }, []);

  const openAction = useCallback(
    (e, action, isMobile) => {
      // eslint-disable-next-line default-case
      switch (action) {
        case "VIEW": {
          getTransactionDetails(e, isMobile);
          break;
        }
      }
    },
    [getTransactionDetails]
  );

  const getTransactions = useCallback(
    (queryParams = null, isReload = false) => {
      if (queryParams) {
        setPageNo(0);
      }
      setCurrentIndex(0);
      setTransactions([]);
      // closeModal();
      let params = {
        page: pageNo,
        size: 10,
      };
      if ((queryParams || searchParams) && !isReload) {
        setSearch(true);
        if (queryParams) {
          params = {
            ...params,
            page: 0,
            ...queryParams,
          };
          setSearchParams(params);
        } else {
          params = {
            ...params,
            ...searchParams,
            page: pageNo,
          };
        }
      }
      params = HELPER.TO_URL_STRING(params);
      SERVICES.GET_FRONT_OFFICE_BULK_SETTLEMENT_TRANSACTION(
        params,
        props.bulkSettlementKey
      )
        .then((data) => {
          const result = data?.result?.content;
          if (!result.length) {
            setEmptyText("No transactions found...");
          } else {
            let arr = [];
            setTotalItems(data?.result.totalElements); //need adjustment
            setTotalPages(data?.result.totalPages); //need adjustment
            result.forEach((e) => {
              arr.push({ ...e, actions: "CR", detailsFunction: openAction });
            });
            setTransactions(arr);
          }
          setError(null);
          setCurrentIndex(1);
          // setLoading(false);
        })
        .catch((error) => {
          setError(HELPER.PROCESS_ERROR(error));
          setCurrentIndex(1);
        });
    },
    [pageNo, searchParams, props.bulkSettlementKey, openAction]
  );

  useEffect(() => {
    getTransactions();
  }, [getTransactions]);

  function goToPage(pageNo) {
    setPageNo(pageNo);
  }

  function reload() {
    setPageNo(0);
    setSearchParams(null);
    setSearch(false);
    setCurrentIndex(0);
    getTransactions(null, true);
  }

  function goBack() {
    setCurrentIndex(1);
  }

  const bulkTransactionView = () => {
    // eslint-disable-next-line default-case
    switch (currentIndex) {
      case 0:
        return (
          <div className="loading-container tab">
            <CustomLoader loadingText="Loading transactions..." />
          </div>
        );
      case 1:
        return (
          <CustomTable
            isReload={true}
            totalPages={totalPages}
            totalItems={totalItems}
            currentPage={pageNo + 1}
            range={range}
            emptyText={emptyText}
            search={search}
            reload={reload}
            error={error}
            items={transactions}
            headers={tableHeaders}
            nextPage={() => setPageNo(pageNo + 1)}
            prevPage={() => setPageNo(pageNo - 1)}
            goToFirstPage={() => setPageNo(0)}
            goToLastPage={() => setPageNo(totalPages - 1)}
            goToPage={goToPage}
          />
        );
      case 2:
        return (
          <div className="mobile-modal-container">
            <div className="custom-card"></div>
          </div>
        );
      case 3:
        return (
          <div className="p-mt-2">
            <BulkTransactionBreakDown
              goBack={goBack}
              isMobile={props.isMobile}
              details={details}
            />
          </div>
        );
    }
  };

  return (
    <div>
      <Toast ref={toast} />
      <div className="p-mt-6"></div>

      <Optional show={HELPER.HAS_AUTHORITY("fo_dd_get_transactions_per_bulk")}>
        {bulkTransactionView()}
      </Optional>
      <Optional show={!HELPER.HAS_AUTHORITY("fo_dd_get_transactions_per_bulk")}>
        <AccessDenied />
      </Optional>
    </div>
  );
}
